export const propMiscModals = {
  policia: {
    title: "Registra i dati",
    heading: "Registra i dati delle autorità competenti",
    subtitle:
      "Sincronizza automaticamente i check-in della tua struttura con le autorità",
    entityLabel: "Nome dell'ente",
    entityPlaceholder: "Seleziona un ente",
    userLabel: "Nome utente",
    passwordLabel: "Password",
    accessError:
      "Controlla le tue credenziali di accesso; ti consigliamo di non provare più di tre volte per evitare di bloccare il tuo account.",
    validateBtn: "Convalida",
    saveBtn: "Salva i dati",
    entityRequired: "L'ente è obbligatorio",
    usernameRequired: "Il nome utente è obbligatorio",
    passwordRequired: "Devi inserire la password",
    validateError: "Errore durante la convalida dei dati",
    saveError: "Errore durante il salvataggio dei dati della polizia",
  },
  upgrade: {
    heading: "Aggiorna il tuo piano per continuare a creare strutture",
    message:
      "Ciao! Abbiamo notato che hai raggiunto il limite di strutture consentite dal tuo piano attuale.",
    button: "Aggiorna piano",
  },
};
